import queryString from "query-string";
import useQuery from "../../../hooks/useQuery";
import { showErrorToastify, showSuccessToastify } from "../../../utils";
import { downloadImpresionConFiltro, downloadImpresionVoucher } from "./api";
import { useState } from "react";
import { useParams } from 'react-router-dom';


const useImprimir = (tipo = "tickets") => {
  const [filter, setFilter] = useState({
    desde: "",
    hasta: "",
    nombre: ""
  });
  const [tarifaId, setTarifaId] = useState(null);
  const { id } = useParams();
  // const [blob, setBlob] = useState(null);

  const { loading, refetch, data } = useQuery({
    queryFn: tipo === "vouchers" ? downloadImpresionVoucher : downloadImpresionConFiltro,
    onSuccess: response => {
      showSuccessToastify({ res: "La descarga se realizó con éxito" })
    },
    onError: err => showErrorToastify({ err }),
    autoFetch: false,
  });

  const onTarifaChange = (value) => {
    setTarifaId(value)
  };

  const fetch = (extraParams = {}, dimensiones = {}) => {
    const query = queryString.stringify({
      desde: filter.desde,
      hasta: filter.hasta,
      nombre: filter.nombre,
      ancho: dimensiones.ancho,
      alto: dimensiones.alto,
      cantidad_fila: (!dimensiones.cantidad_fila || dimensiones.cantidad_fila === "" || dimensiones.cantidad_fila === 0) ? 1 : dimensiones.cantidad_fila,
      margen: dimensiones.margen,
      ...extraParams,
    })

    if (!tarifaId) return showErrorToastify({ err: "Debes seleccionar una tarifa" })

    refetch(id, tarifaId, query);
  };

  const onFormChange = (newFilter) => {
    setFilter(filter => ({ ...filter, ...newFilter }));
  }

  return {
    fetch,
    archivo: data,
    loading,
    onFormChange,
    onTarifaChange,
    filter,
  };
};

export default useImprimir;